import { render, staticRenderFns } from "./ProductImageWatermark.vue?vue&type=template&id=e28e2db6&scoped=true&"
import script from "./ProductImageWatermark.vue?vue&type=script&lang=js&"
export * from "./ProductImageWatermark.vue?vue&type=script&lang=js&"
import style0 from "./ProductImageWatermark.vue?vue&type=style&index=0&id=e28e2db6&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e28e2db6",
  null
  
)

export default component.exports